import type { Component, Entity2D } from '../../odie';

import { ButterflyBlockProps } from '../defs/block';
import { ButterflyBlockView } from '../views/blocks/ButterflyBlockView';

// types
//-----------------------------------------------------------------------------
export type ButterflyBlockComponentOptions = {
  props: ButterflyBlockProps;
};

/*
    butterfly block component
*/
export class ButterflyBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockButterfly';

  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: ButterflyBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: ButterflyBlockComponentOptions): void {
    this.view = new ButterflyBlockView({ ...options.props });
  }
}
